<template>
  <div>
    <div v-if="debug_show_page_name == true" style="color: green">
      page_0002_login_expired
    </div>
    <div
      style="
        color: #000000;
        font-size: 30px;
        padding: 27px 50px;
        font-weight: 800;
        background: #5b9bd5;
        color: #ffffff;
      "
    >
      ソフトウェアライセンス管理
      <br />
      <div style="font-size: 20px; color: #ffffff">e-sma</div>
    </div>
    <div :class="'container ' + pageContainerSize">
      <div style="padding-top: 100px">
        <center>
          30分以上ログインが確認出来なかったため、切断されました。<br />
          以下のボタンをクリックし、ログイン画面を再度開いてください。
        </center>
      </div>
      <div style="padding-top: 40px">
        <center>
          <router-link
            tag="button"
            to="/"
            type="button"
            style="width: 200px"
            class="btn btn-primary"
            >ログイン画面へ</router-link
          >
        </center>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { fields, filed_types } from "@/rules/fields_system_setting";
import { utils } from "@/libs/utils";
import _debug from "debug";
var mdebug = _debug("esma:master_belong_details");
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    clearStorage(cb) {
      var keys = Object.keys(window.localStorage);
      keys.forEach((k) => {
        if (k.indexOf("user") == 0) {
          Vue.localStorage.remove(k);
        }
        if (k.indexOf("bulk_edit_") == 0) {
          Vue.localStorage.remove(k);
        }
        if (k.indexOf("associated_device_") == 0) {
          Vue.localStorage.remove(k);
        }
        if (k.indexOf("selectedCompany") == 0) {
          Vue.localStorage.remove(k);
        }
        if (k.indexOf("passwordExpireDate") == 0) {
          Vue.localStorage.remove(k);
        }
      });

      window.sessionStorage.clear();
      return cb();
    },
    onLogoutCompleated() {
      this.clearStorage(()=>{
        this.$store.state.cached_lists = {};
        this.$store.state.last_filter_options = {};
        this.$store.state.last_filter_options2 = {};
        this.$store.state.last_filter_options3 = {};

        this.allow_login_process = false;
        if (this.allow_toast) {
          this.allow_toast = false;
          this.$notify({
            title: "ログアウトしました",
            type: "primary",
            duration: 1000
          });
        }
        setTimeout(() => {
          this.allow_toast = true;
        }, 1200);
      })
    }
  },
  mounted() {
    window.sessionStorage.setItem("tab_id", false);
    Vue.localStorage.set("tab_id", false);
    this.$store.dispatch("makeLogout", {});
    this.onLogoutCompleated({})
  },
  beforeDestroy() {},
  beforeMount() {},
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// page_0002_login_expired.vue?178856ee